import apiClient from "../server";

export const getAllCountries = async () => {
  try {
    const response = await apiClient.get(
      `/params/countries/all?pagination=false`,
    );
    return response.data;
  } catch (error) {
    console.error("Error getting countries:", error.response?.data || error);
    throw error;
  }
};
export const updateCountry = async (countryId, data) => {
  try {
    const response = await apiClient.patch(
      `/params/countries/update/${countryId}`,
      data,
    );
    return response.data;
  } catch (error) {
    console.error("Error updating country:", error.response?.data || error);
    throw error;
  }
};
export const updateCity = async (cityId, data) => {
  try {
    const response = await apiClient.patch(
      `/params/cities/update/${cityId}`,
      data,
    );
    return response.data;
  } catch (error) {
    console.error("Error updating city:", error.response?.data || error);
    throw error;
  }
};
export const getAllEnableCities = async () => {
  try {
    const response = await apiClient.get(`/params/cities/all?isEnabled=true`);
    return response.data;
  } catch (error) {
    console.error("Error getting enabled cities:", error.response?.data || error);
    throw error;
  }
};
export const getCityById = async (cityId) => {
  try {
    const response = await apiClient.get(`/params/cities/get/${cityId}`);
    return response.data;
  } catch (error) {
    console.error("Error fetching city details:", error.response?.data || error);
    throw error;
  }
};
export const createCity = async (cityData) => {
  try {
    const response = await apiClient.post(
      `/params/cities/create`,
      cityData
    );
    return response.data;
  } catch (error) {
    console.error("Error creating city:", error.response?.data || error);
    throw error;
  }
};
export const createCountry = async (countryData) => {
  try {
    const response = await apiClient.post(
      `/params/countries/create`,
      countryData
    );
    return response.data;
  } catch (error) {
    console.error("Error creating country:", error.response?.data || error);
    throw error;
  }
};
